export interface DeviceResult {
    MAC: string;
    Status: string;
    TimeExecute: number;
    Result: any;    
};